import BatchDataConfigApiUrls from 'src/apiUrls/BatchDataConfigApiUrls'
import BatchDataConfigFormProperties from './BatchDataConfigFormProperties'
import React from 'react'
import { components } from 'cng-web-lib'

const {
    form: { CngEditForm }
} = components

function BatchDataConfigEditForm({
    showNotification,
    id,
    onFetchPreSuccess = () => { 
        //do nothing
    }
}) {

    return (
        <CngEditForm
            fieldLevel="toBeChangedByDeveloperIfWantFieldLevelRestriction"
            showNotification={showNotification}
            bodySection={
                <BatchDataConfigFormProperties.Fields
                    showNotification={showNotification}
                />
            }
            formikProps={BatchDataConfigFormProperties.formikProps}
            toClientDataFormat={BatchDataConfigFormProperties.toClientDataFormat}
            toServerDataFormat={BatchDataConfigFormProperties.toServerDataFormat}
            fetch={{
                url: BatchDataConfigApiUrls.GET,
                onPreSuccess: onFetchPreSuccess
            }}
            update={{
                url: BatchDataConfigApiUrls.PUT
            }}
            id={id}
        />
    )
}

export default BatchDataConfigEditForm
